import { render, staticRenderFns } from "./MosadNotFoundMessage.vue?vue&type=template&id=c3cb08e6&scoped=true&"
import script from "./MosadNotFoundMessage.vue?vue&type=script&lang=js&"
export * from "./MosadNotFoundMessage.vue?vue&type=script&lang=js&"
import style0 from "./MosadNotFoundMessage.vue?vue&type=style&index=0&id=c3cb08e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cb08e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCardText,VCol,VRow})
